import type { Question } from "../../types/onboarding";

export interface ProfileSectionConfig {
	id: string;
	titleKey: string;
	questionType: string;
	fieldName: string;
	question: Question;
	componentType:
		| "SetupProfile"
		| "SetupProfileDetails"
		| "FertilityStatus"
		| "FertilityRole"
		| "FertilityJourneyTypes"
		| "AdditionalInfo"
		| "ClinicProvider"
		| "ChangePassword";
}

export const profileSections: ProfileSectionConfig[] = [
	{
		id: "name-location",
		titleKey: "setupProfile.title",
		questionType: "setup-profile",
		fieldName: "setupProfile",
		componentType: "SetupProfile",
		question: {
			id: "name-location",
			type: "setup-profile",
			title: "Name and location",
			question: "Tell us your name and location",
			field: "setupProfile",
		},
	},
	{
		id: "birth-year-gender",
		titleKey: "setupProfileDetails.title",
		questionType: "setup-profile-details",
		fieldName: "setupProfileDetails",
		componentType: "SetupProfileDetails",
		question: {
			id: "birth-year-gender",
			type: "setup-profile-details",
			title: "Birth year and gender",
			question: "Tell us your birth year and gender",
			field: "setupProfileDetails",
		},
	},
	{
		id: "current-status",
		titleKey: "fertilityStatus.title",
		questionType: "fertility-status",
		fieldName: "fertilityStatus",
		componentType: "FertilityStatus",
		question: {
			id: "current-status",
			type: "fertility-status",
			title: "Current status",
			question: "What is your current fertility status?",
			field: "fertilityStatus",
		},
	},
	{
		id: "fertility-role",
		titleKey: "fertilityRole.title",
		questionType: "fertility-role",
		fieldName: "fertilityRole",
		componentType: "FertilityRole",
		question: {
			id: "fertility-role",
			type: "fertility-role",
			title: "Fertility journey role",
			question: "What is your role in the fertility journey?",
			field: "fertilityRole",
		},
	},
	{
		id: "journey-type",
		titleKey: "fertilityJourneyTypes.title",
		questionType: "fertility-journey-types",
		fieldName: "fertilityJourneyTypes",
		componentType: "FertilityJourneyTypes",
		question: {
			id: "journey-type",
			type: "fertility-journey-types",
			title: "Journey type",
			question: "Which fertility journey types apply to you?",
			field: "fertilityJourneyTypes",
		},
	},
	{
		id: "additional-medical-info",
		titleKey: "additionalInfo.title",
		questionType: "additional-info",
		fieldName: "additionalInformation",
		componentType: "AdditionalInfo",
		question: {
			id: "additional-medical-info",
			type: "additional-info",
			title: "Additional medical info",
			question: "Any additional medical information?",
			field: "additionalInformation",
		},
	},
	{
		id: "clinic",
		titleKey: "questions.clinicProvider.title",
		questionType: "clinic-provider",
		fieldName: "clinic",
		componentType: "ClinicProvider",
		question: {
			id: "clinic",
			type: "select-provider",
			title: "Your Clinic",
			question: "Do you have a clinic or provider?",
			field: "clinic",
		},
	},
];
